import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormArray, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { NotificationService } from 'src/app/services/notification.service';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step5-trustee',
  templateUrl: './step5-trustee.component.html',
  styleUrls: ['./step5-trustee.component.scss'],
  animations: [
    trigger('bounceIn', [
      state('in', style({ opacity: 1, transform: 'scale(1)' })),
      transition('void => *', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('0.15s ease-in-out')
      ]),
      transition('* => void', [
        animate('0.15s ease-in-out', style({ opacity: 0, transform: 'scale(0.7)' }))
      ])
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.15s ease-in-out', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('0.15s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class Step5TrusteeComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() scrollUp = new EventEmitter<number>();
  @ViewChild('suggestBox', { static: false }) suggestBox?: ElementRef;

  
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  title: string = 'Trustees';
  subtitle: string = 'Add one or more trustees.';

  trusteeTypeLabel: string = 'Type of Trustee';
  trusteeTypeHint: string = 'Type of trustee';

  relationLabel: string = 'Relationship To Settlor';
  relationHint: string = 'Specify Relationship';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';
  genderLabel: string = 'Gender';
  genderHint: string = 'Select gender';
  phoneLabel : string = 'Primary Phone Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';

  institutionNameLabel: string = 'Name of Institution';
  businessNatureLabel: string = 'Nature of Business';
  orgRegNumLabel: string = 'Organization Registration Number';
  orgAddressLabel: string = 'Postal Address';
  orgAddressHint: string = 'Enter Postal Address';
  
  institutionNameHint: string = 'Enter name';
  businessNatureHint: string = 'Enter nature of business';
  orgRegNumHint: string = 'Enter registration Number';
  

  additionalDetailsText: string = 'Upload Documents';

  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA PIN';
  kraHint: string = 'Enter KRA PIN';
  idFileLabel: string = 'Upload Copy of ID/Passport';
  passportLabel: string = 'Upload Passport Photo';
  cvLabel: string = 'Curriculum Vitae';

  regCertFileLabel: string = 'Upload Registration Certificate';
  kraFileLabel: string = 'Upload KRA PIN';

  addBenText: string = 'Add Another Trustee';
  removeBenText: string = 'Remove Trustee';

  addText: string = 'Trustee details saved';
  updateText: string = 'Trustee details updated'
  
  requiredFieldString: string = 'Required field';
  invalidDocString: string = 'Please attach a valid document';

  buttonDisabled: boolean = true;
  addDisabled: boolean = true;

  loadingText: string = 'Saving Trustee';

  loadingRemove: boolean = false;
  removeButtonText: string = 'Remove Trustee';
  removeContactText: string = 'Remove Contact';
  navigationRequested: boolean = false;
  currentIndex: number = 0;
  shouldInsert: boolean = false;

  selfRecords: any = []; // For suggesting self
  recordUpdate: any;

  formErrors: { [key: string]: string } = {
    Category: '',
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Phone: '',
    Email: '',
    Relationship: '',
    Other: '',

    IDNo: '',
    KraPin: '',

    IDNoImage: '',
    KraPinImage: '',
    PassportImage: '',
    CvImage: '',

    InstitutionName: '',
    BusinessNature: '',
    OrgRegNum: '',
    PostalAddress: '',
    RegCertImage: '',
    
  };

  validationMessages: { [key: string]: {} } = {
    Category: { required: this.requiredFieldString },
    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    Phone: {
      required: this.requiredFieldString,
      pattern:'Invalid phone number',
      exist: `${
        this.trustees[this.trustees.length-1] &&
        this.trustees[this.trustees.length-1].personalDone &&
        this.trustees[this.trustees.length-1].personalDone == true ? 'This number is tied to an existing contact' : 'This number is tied to an existing trustee' }` },
    Email: {
      required: this.requiredFieldString,
      email: "Invalid email address",
      exist: `${
        this.trustees[this.trustees.length-1] &&
        this.trustees[this.trustees.length-1].personalDone &&
        this.trustees[this.trustees.length-1].personalDone == true ? 'This email is tied to an existing contact' : 'This email is tied to an existing trustee' }` },

    IDNo:  { required: this.requiredFieldString, pattern:'Invalid ID or Passport number', exist: 'This ID is tied to an existing trustee' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing trustee' },
    Relationship: { required: this.requiredFieldString },
    Other: {required: this.requiredFieldString},

    IDNoImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    KraPinImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    PassportImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    CvImage: { required: this.requiredFieldString, invalid: this.invalidDocString },

    InstitutionName: { required: this.requiredFieldString },
    BusinessNature: { required: this.requiredFieldString },
    OrgRegNum: { required: this.requiredFieldString },
    PostalAddress: { required: this.requiredFieldString },

    RegCertImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    
  };

  trusteeForm = this._formBuilder.group({
    trustees: this._formBuilder.array([
      this.createTrusteeFormGroup()
    ]),
  });

  trusteePanels: ExpansionPanel[][] = [];
  private formChangesSubscription: Subscription[] = [];
  

  constructor(
    private _formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private validationService: ValidationService,
    private apiService: ApiService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit(): Promise<void> {
    const records: any = this.settlors;
    this.selfRecords.push(records[0]);
    if (records.length > 1) this.selfRecords.push(records[1]);

    if (this.trustees && this.trustees.length > 0) {
      if (this.trustees[0].personalDone
        && this.trustees[0].personalDone == true) {
        const trusteesArray = this.trusteeForm.get('trustees') as FormArray;
        
        // Filter out the unverified settlors and reassign the array
        const dat = this.trustees.filter((trustee: any) => trustee.personalDone == true);
        await this.estateControlService.updateRecord(5, dat);
        
        // Clear existing trustees
        while (trusteesArray.length !== 0) {
          trusteesArray.removeAt(0);
        }

        // Add trustees from storage
        this.trustees.forEach((trustee: any) => {
          trusteesArray.push(this.createTrusteeFormGroup(trustee));
        });

        this.estateControlService.updateStorageObject();
      }
    }

    if (this.estateControlService.activeTab == 5) {
      this.populateData();
    }

    // Initialize all bensPanels with their FormGroup already created
    this.getTrustees().controls.forEach((_, i) => {
      if (!this.trusteePanels[i]) {
        this.trusteePanels[i] = this.generatePanelsForTrustee(i);
      }
    });

    this.setupFormChangeListeners();

    this.trusteeForm.valueChanges.subscribe(() => {
      this.logErrors();
      // console.log('::::::::::::::::::::::::::::: FORM + CONTROLS DEBUG\n', this.getTrustees().controls);
    });
  }

  ngAfterViewInit() {
    setTimeout(()=> {
      this.trustees.forEach((_: any, i: number) => {
        if (this.trusteeForm && this.getTrusteeFormGroup(i)) {
          this.trusteePanels[i] = this.generatePanelsForTrustee(i);
        }
      });
    })
  }

  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.trusteeForm,
      this.formErrors,
      this.validationMessages
    );
  }

  businessNatureEmpty: boolean = true;

  // Autofill settlors
  showSuggestHint: boolean = false;
  showAssignPopup: boolean = false;
  autofilled: boolean = false;
  suggestions: any = null;
  briefTimeout: any;

  get settlors(): any {
    return this.estateControlService.settlors;
  }

  // ===============================================

  get region(): any {
    return this.estateControlService.regionType;
  }
  get loading(): boolean {
    return this.notificationService.loading;
  }
  get trustees(): any {
    return this.estateControlService.trustees;
  }

  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }
  get TrusteeOptions():any {
    return this.estateControlService.TrusteeOptions;
  }

  get loadingBizNature(): boolean {
    return this.tabControlService.loadingBizNature;
  }
  get BusinessNatureOptions(): any {
    return this.tabControlService.BusinessNatureOptions;
  }
  get RelationOptions():any {
    return this.tabControlService.RelationOptions;
  }
  Relationships: any = this.RelationOptions;

  get saveProgress(): ()=> void {
    return this.tabControlService.saveProgress;
  }

  showSuggestBrief(): void {
    setTimeout(() => {
      this.showSuggestHint = true;
    }, 1000);

    this.briefTimeout = setTimeout(() => {
      this.showSuggestHint = false;
    }, 30000);
  }
  async suggestSettlors(val: string, index: number): Promise<any> {
    if (this.autofilled) {
      this.resetForm(index);
    }
    
    this.suggestions = null;
    let validEntries: any = [];

    if (val.length > 2) {
        try {
            const fields = this.trusteeForm.get('trustees') as FormArray;

            for (let i = 0; i < this.settlors.length; i++) {
              let exist = false;
              let trueStuff = this.settlors[i].IDNo.includes(val);

              if (trueStuff) {
                for (let j = 0; j < fields.length - 1; j++) {
                    if (
                      fields.at(j).get('IDNo')?.value === this.settlors[i].IDNo ||
                      fields.at(j).get('Phone')?.value === this.settlors[i].Phone ||
                      fields.at(j).get('KraPin')?.value === this.settlors[i].KraPin) {
                        exist = true;
                    } else {
                      this.showSuggestHint = false;
                      clearTimeout(this.briefTimeout);
                    }
                }

                if (!exist && validEntries.length < 3 && !validEntries.some((entry: { IDNo: string; }) => entry.IDNo === this.settlors[i].IDNo)) {
                    validEntries.push(this.settlors[i]);
                }
              }
            }

            if (validEntries.length > 0) {
              this.suggestions = validEntries;
            }
            if (this.suggestions !== null) {
              const childDivHeight = this.suggestBox?.nativeElement.clientHeight;
              this.scrollUp.emit(childDivHeight);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return this.suggestions;
  }
  patchSuggestedValues(index: number, value: any): void {
    try {
      if (value) {
        const fields = this.trusteeForm.get('trustees') as FormArray;
        fields.removeAt(index);
        fields.insert(index, this.createTrusteeFormGroup(value, true, null, index));

        this.trusteeForm.setControl('trustees', fields);
        
        this.suggestions = null;
        this.autofilled = true;
      }

    } catch (error) {
      console.error('ERR ??? ', error);
    }
  }

  resetForm(index: number): void {
    try {
      this.autofilled = false;

      const trustee = this.getTrustees().at(index) as FormGroup;
      trustee.get('Title')?.setValue('');
      trustee.get('FirstName')?.setValue('');
      trustee.get('MiddleName')?.setValue('');
      trustee.get('LastName')?.setValue('');
      trustee.get('Phone')?.setValue('7');
      trustee.get('Email')?.setValue('');
      trustee.get('IDNo')?.setValue('');
      trustee.get('KraPin')?.setValue('');
      trustee.get('IDNoImage')?.setValue('');
      trustee.get('KraPinImage')?.setValue('');
      trustee.get('PassportImage')?.setValue('');
      trustee.get('CvImage')?.setValue('');

      this.updateIDObject(index, null);
      this.updateKraObject(index, null);
      this.updatePassportObject(index, null);
      this.updateCVObject(index, null);

    } catch (error) {
      console.error('ResetForm ', error);
    }
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
    if (this.BusinessNatureOptions.length === 0) {
      this.tabControlService.loadingBizNature = true;
      await this.tabControlService.getBusinessNatOptionsList();
      this.tabControlService.loadingBizNature = false;
    }
  }

  arrayContainsValue(arr: string | null | undefined, value: string) {
    return arr && arr.includes(value);
  }

  updateIDObject(index: number, object: any): void {
    const trustees = this.trustees;
    const latestRecord = trustees[index];
    let updatedRecord = {
      ...latestRecord,
      ...{IDNoImage: object}
    };
    Object.assign(trustees[index], updatedRecord);
    this.estateControlService.updateRecord(5, trustees);
  }
  updateKraObject(index: number, object: any): void {
    const trustees = this.trustees;
    const latestRecord = trustees[index];
    let updatedRecord = {
      ...latestRecord,
      ...{KraPinImage: object}
    };
    Object.assign(trustees[index], updatedRecord);
    this.estateControlService.updateRecord(5, trustees);
  }
  updatePassportObject(index: number, object: any): void {
    const trustees = this.trustees;
    const latestRecord = trustees[index];
    let updatedRecord = {
      ...latestRecord,
      ...{PassportImage: object}
    };
    Object.assign(trustees[index], updatedRecord);
    this.estateControlService.updateRecord(5, trustees);
  }
  updateCVObject(index: number, object: any): void {
    const trustees = this.trustees;
    const latestRecord = trustees[index];
    let updatedRecord = {
      ...latestRecord,
      ...{CvImage: object}
    };
    Object.assign(trustees[index], updatedRecord);
    this.estateControlService.updateRecord(5, trustees);
  }
  updateRegCertObject(index: number, object: any): void {
    const trustees = this.trustees;
    const latestRecord = trustees[index];
    let updatedRecord = {
      ...latestRecord,
      ...{RegCertImage: object}
    };
    Object.assign(trustees[index], updatedRecord);
    this.estateControlService.updateRecord(5, trustees);
  }

  onTrusteeTypeChange(index: number): void {
    try {
      if (this.autofilled) this.resetForm(index);

      this.ngZone.runOutsideAngular(() => {
        // Batch all form control updates
        setTimeout(() => {
          const formGroup = this.getTrusteeFormGroup(index);
          const beneType = formGroup.get('Category')?.value;

          if (!beneType) return;

          // Disable automatic change detection during updates
          this.ngZone.run(() => {
            if (beneType.toLowerCase() === 'individual trustee') {
              this.orgAddressHint = 'Enter Postal Address';
              this.orgAddressLabel = 'Postal Address';

              ['InstitutionName', 'BusinessNature', 'OrgRegNum', 'KraPin', 'PostalAddress']
                .forEach(controlName => {
                  formGroup.get(controlName)?.clearValidators();
                  formGroup.get(controlName)?.setValue('');
                });

              // Batch add individual validators
              ['Relationship', 'FirstName', 'LastName', 'IDNo', 'Title']
                .forEach(controlName => {
                  this.validationService.addOrRemoveValidator(true, formGroup.get(controlName)!);
                  if (controlName === 'Relationship') {
                    this.validationService.addOrRemoveValidationOnValue(
                      this.getTrusteeFormGroup(index).get("Relationship")!,
                      "Other",
                      this.getTrusteeFormGroup(index),
                      "Other"
                    );
                  }
              });
              
            } else {
              this.orgAddressHint = 'Enter Physical Address';
              this.orgAddressLabel = 'Organisation Physical Address';

              // Batch clear individual controls
              ['Title', 'FirstName', 'MiddleName', 'LastName',
                'Relationship', 'Other', 'Phone', 'Email', 'PostalAddress', 'IDNo', 'KraPin'
              ].forEach(controlName => {
                if (controlName !== 'PostalAddress' && controlName !== 'KraPin')
                  formGroup.get(controlName)?.clearValidators();
                formGroup.get(controlName)?.setValue('');
              });
              this.toggleFormControls(index, true);

              // Batch add institution validators
              ['InstitutionName', 'BusinessNature', 'OrgRegNum', 'PostalAddress', 'KraPin']
                .forEach(controlName => {
                  this.validationService.addOrRemoveValidator(true, formGroup.get(controlName)!);
                  if (controlName === 'KraPin') {
                    this.validationService.addOrRemove3Validators(
                      true,
                      this.getTrusteeFormGroup(index).get('KraPin')!,
                      [Validators.required,
                        Validators.pattern(/^[AP]\d{9}[A-Z]$/),
                        createIDsValidatorEstate('PIN', this.getTrustees(), this.trustees)
                      ]
                    );
                  }
              });
            }

            // Force panel regeneration after category change
            this.trusteePanels[index] = this.generatePanelsForTrustee(index);
            this.cdr.markForCheck();
          });
        });
      });
    } catch (error) {
      console.error('trustee change error !!! ', error);
    }
    
  }

  hasSelfRelationship: boolean = false;

  trackByFn(index: number, item: any) {
    return index; // Or a unique ID if available
  }
  onRelationshipChange(index: number): void {
    const value = this.getTrusteeFormGroup(index)?.get('Relationship')?.value;
    if (value) {
      switch (value.toLowerCase()) {
        case 'self':
          const fields = this.trusteeForm.get('trustees') as FormArray;
          this.recordUpdate = this.selfRecords[0];
          let counter: number = 0;
          
          this.hasSelfRelationship = fields.controls.some(group => {  
            if (group.get('Relationship')?.value.toLowerCase() === 'self') {
              counter++;
            }
            return counter > 1;
          });
          // To autofill second settlor / testator
          if (this.hasSelfRelationship && this.selfRecords.length > 1)
            this.recordUpdate = this.selfRecords[1];

          fields.removeAt(index);
          fields.insert(index, this.createTrusteeFormGroup(this.recordUpdate, false, value, index));

          this.trusteeForm.setControl('trustees', fields);
          this.toggleFormControls(index, false);

          break;
        default:
          this.toggleFormControls(index, true);
          break;
      }
    }
  }

  toggleFormControls(index: number, enabled: boolean): void {
    if (enabled) { // Reset form when relationship != self
      const isSelfRecord: boolean = this.selfRecords.some((record: any) => {
        return this.getTrusteeFormGroup(index).get('IDNo')?.value == record.IDNo;
      });

      if (isSelfRecord) {
        this.getTrusteeFormGroup(index)?.get('Title')?.enable();
        this.getTrusteeFormGroup(index)?.get('FirstName')?.enable();
        this.getTrusteeFormGroup(index)?.get('MiddleName')?.enable();
        this.getTrusteeFormGroup(index)?.get('LastName')?.enable();
        this.getTrusteeFormGroup(index)?.get('Phone')?.enable();
        this.getTrusteeFormGroup(index)?.get('Email')?.enable();
        this.getTrusteeFormGroup(index).get('IDNo')?.enable();
        this.getTrusteeFormGroup(index).get('KraPin')?.enable();
        this.getTrusteeFormGroup(index).get('PostalAddress')?.enable();
        this.getTrusteeFormGroup(index)?.get('IDNoImage')?.enable();
        this.getTrusteeFormGroup(index)?.get('KraPinImage')?.enable();
        this.getTrusteeFormGroup(index)?.get('PassportImage')?.enable();

        this.getTrusteeFormGroup(index)?.get('Title')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('FirstName')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('MiddleName')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('LastName')?.setValue('');

        this.getTrusteeFormGroup(index).get('Phone')?.setValue(' ');    
        this.getTrusteeFormGroup(index)?.get('Email')?.setValue('');
        this.getTrusteeFormGroup(index).get('IDNo')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('KraPin')?.setValue('');
        this.getTrusteeFormGroup(index).get('PostalAddress')?.setValue('');

        this.getTrusteeFormGroup(index)?.get('IDNoImage')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('KraPinImage')?.setValue('');
        this.getTrusteeFormGroup(index)?.get('PassportImage')?.setValue('');
      }

    } else {
      // For 'self' option under relationship
      this.getTrusteeFormGroup(index)?.get('Title')?.disable();
      this.getTrusteeFormGroup(index)?.get('FirstName')?.disable();
      this.getTrusteeFormGroup(index)?.get('MiddleName')?.disable();
      this.getTrusteeFormGroup(index)?.get('LastName')?.disable();

      this.getTrusteeFormGroup(index)?.get('Phone')?.disable();
      this.getTrusteeFormGroup(index)?.get('Email')?.disable();  
      this.getTrusteeFormGroup(index).get('IDNo')?.disable();
      this.getTrusteeFormGroup(index).get('KraPin')?.disable();
      this.getTrusteeFormGroup(index).get('PostalAddress')?.disable();

      this.getTrusteeFormGroup(index)?.get('IDNoImage')?.disable();
      this.getTrusteeFormGroup(index)?.get('KraPinImage')?.disable();
      this.getTrusteeFormGroup(index)?.get('PassportImage')?.disable();
    }
    this.trusteeForm.updateValueAndValidity();
  }

  createTrusteeFormGroup(trustee: any = null, patch: boolean = false, value: any = null, index?: number): FormGroup {
    let form: FormGroup;
    let category = this.TrusteeOptions[0];

    if (this.trusteeForm && this.getTrustees().length > 0) {
      category = this.TrusteeOptions[1];
    }
    const setIndex = index ?? this.trustees.length-1;

    if (trustee) {
      if (patch) this.autofilled = true;
      const contact = trustee.ContactPersons && trustee.ContactPersons[0] ? trustee.ContactPersons[0] : null;

      form = this._formBuilder.group({
        Category: [`${value ? this.TrusteeOptions[0] : patch ? category : trustee.Category || this.TrusteeOptions[0]}`, Validators.required],
        Relationship: [`${value ? value : trustee.Relationship || ''}`],
        Title: [`${trustee.Title || ''}`],
        FirstName: [`${trustee.FirstName || ''}`],
        MiddleName: [`${trustee.MiddleName || ''}`],
        LastName: [`${trustee.LastName || ''}`],
        Phone: [`${trustee.Phone || ''}`],
        Email: [`${trustee.Email || ''}`, Validators.email],
        Other: [`${trustee.Other || ''}`],
        ContactPersons:  this._formBuilder.array([
          this.createContactsGroup(contact, null, trustee)
        ]),
  
        IDNo: [`${trustee.IDNo || ''}`],
        KraPin: [`${trustee.KraPin || ''}`],

        IDNoImage: [''],
        KraPinImage: [''],
        PassportImage: [''],
        CvImage: [''],
  
        InstitutionName: [`${trustee.InstitutionName || ''}`],
        BusinessNature: [`${trustee.BusinessNature || ''}`],
        OrgRegNum: [`${trustee.OrgRegNum || ''}`],
        PostalAddress: [`${trustee.PostalAddress || ''}`, Validators.required],
  
        RegCertImage: ['']
      }) as FormGroup & { [key: string]: AbstractControl };

      if (trustee.ContactPersons && trustee.ContactPersons.length > 0) {
        const contactArray = form.get('ContactPersons') as FormArray;

        trustee.ContactPersons.forEach((contact: any, index: number) => {
          if (index > 0) contactArray.push(this.createContactsGroup(contact, contactArray, trustee));
        });
      }

      if ((!value || !patch) && trustee.IDNoImage) {
        if (trustee.IDNoImage?.stringValue && trustee.IDNoImage?.stringValue.length > 0) {
          form.get('IDNoImage')?.setValue(trustee.IDNoImage.stringValue);
        }
      }
      if ((!value || !patch) && trustee.KraPinImage) {
        if (trustee.KraPinImage.stringValue && trustee.KraPinImage.stringValue.length > 0) {
          form.get('KraPinImage')?.setValue(trustee.KraPinImage.stringValue);
        }
      }
      if ((!value || !patch) && trustee.PassportImage) {
        if (trustee.PassportImage.stringValue && trustee.PassportImage.stringValue.length > 0) {
          form.get('PassportImage')?.setValue(trustee.PassportImage.stringValue);
        }
      }
      if (!patch && trustee.CvImage) {
        if (trustee.CvImage.stringValue && trustee.CvImage.stringValue.length > 0) {
          form.get('CvImage')?.setValue(trustee.CvImage.stringValue);
        }
      }
      if (!patch && trustee.RegCertImage) {
        if (trustee.RegCertImage.stringValue && trustee.RegCertImage.stringValue.length > 0) {
          form.get('RegCertImage')?.setValue(trustee.RegCertImage.stringValue);
        }
      }

      let cat: string = trustee.Category || '';
      if (patch) cat = category;

      if (!trustee.personalDone || cat?.toLowerCase() === 'individual trustee' || value) {
        form.get('FirstName')?.addValidators(Validators.required);
        form.get('LastName')?.addValidators(Validators.required);
        form.get('Phone')?.addValidators(Validators.required);
        form.get('Email')?.addValidators([Validators.required, Validators.email]);
        form.get('Relationship')?.addValidators(Validators.required);

        form.get('IDNo')?.addValidators(Validators.required);
        if (this.region === 0) form.get('KraPin')?.addValidators(Validators.required);
        form.get('PostalAddress')?.addValidators(Validators.required);

        this.validationService.addOrRemoveValidationOnValue(
          form.get("Relationship")!,
          "Other",
          form,
          "Other"
        );

        if (patch || trustee.contactsDone || value) {
          if (trustee.contactsDone) {
            form.get('IDNoImage')?.addValidators(Validators.required);
            if (this.region === 0) form.get('KraPinImage')?.addValidators(Validators.required);
            form.get('PassportImage')?.addValidators(Validators.required);
            form.get('CvImage')?.addValidators(Validators.required);
          }

          if (!trustee.done || value) {
            // Autofill for self relationship
            this.selfRecords.some((record: any) => {
              if (
                value ||
                trustee.Relationship == 'Self' &&
                trustee.FirstName == record.FirstName &&
                trustee.LastName == record.LastName &&
                trustee.Phone == record.Phone &&
                trustee.Email == record.Email
              ) {
                this.recordUpdate = record;
                if (record.IDNoImage.stringValue && record.IDNoImage.stringValue.length > 0) {
                  form.get('IDNoImage')?.setValue(record.IDNoImage.stringValue);
                  this.updateIDObject(setIndex, record.IDNoImage);
                }
                if (record.KraPinImage.stringValue && record.KraPinImage.stringValue.length > 0) {
                  form.get('KraPinImage')?.setValue(record.KraPinImage.stringValue);
                  this.updateKraObject(setIndex, record.KraPinImage);
                }
                if (record.PassportImage.stringValue && record.PassportImage.stringValue.length > 0) {
                  form.get('PassportImage')?.setValue(record.PassportImage.stringValue);
                  this.updatePassportObject(setIndex, record.PassportImage);
                }
              }
            })
          }
        }

        if (value || trustee.Relationship == 'Self') {
          form.get('Title')?.disable();
          form.get('FirstName')?.disable();
          form.get('MiddleName')?.disable();
          form.get('LastName')?.disable();
          form.get('Phone')?.disable();
          form.get('Email')?.disable();
          form.get('IDNo')?.disable();
          form.get('KraPin')?.disable();
          form.get('PostalAddress')?.disable();
          form.get('IDNoImage')?.disable();
          form.get('KraPinImage')?.disable();
          form.get('PassportImage')?.disable();

          if (this.estateControlService.activeTab == 5) {
            this.notificationService.viewToast(
              'info',
              `Trustee ${trustee.FirstName+' '+trustee.LastName} is also a settlor.`,
              `To modify previously saved details and documents, edit the settlor record itself`
            );
          }
        }

      } else {
        form.get('InstitutionName')?.addValidators(Validators.required);
        form.get('BusinessNature')?.addValidators(Validators.required);
        form.get('OrgRegNum')?.addValidators(Validators.required);
        form.get('PostalAddress')?.addValidators(Validators.required);
        form.get('KraPin')?.addValidators(Validators.required);

        if (trustee.contactsDone) {
          form.get('RegCertImage')?.addValidators(Validators.required);
          form.get('KraPinImage')?.addValidators(Validators.required);
        }
      }

      form.updateValueAndValidity();

    } else {
      this.showSuggestBrief();

      if (
        this.trustees && this.trustees.length > 0 &&
        !(this.trustees[0].personalDone && this.trustees[0].personalDone == true)
      ) {
          this.estateControlService.refreshRecord(5);
      }
      
      let currentTrustees = this.trustees;
      let currentRecord = {personalDone: false, done: false, contactsDone: false};

      if (
        (this.trusteeForm && this.getTrustees().length > 0) ||
        this.trustees &&
        (this.trustees.length > 0 &&
          !(this.trustees[0].personalDone && this.trustees[0].personalDone == true) ) ||
        this.trustees.length == 0
      ) {
        currentTrustees.push(currentRecord);
        this.estateControlService.updateRecord(5, currentTrustees);
      }
      
      form = this._formBuilder.group({
        Category: [this.TrusteeOptions[0], Validators.required],
        Relationship: ['', Validators.required],
        Title: [''],
        FirstName: ['', Validators.required],
        MiddleName: [''],
        LastName: ['', Validators.required],
        Phone: ['', Validators.required],
        Email: ['', [Validators.required, Validators.email]],
        Other: [''],
        ContactPersons: this._formBuilder.array([
          this.createContactsGroup(null, null, this.trustees[this.trustees.length-1])]
        ),
  
        IDNo: ['', Validators.required],
        KraPin: ['', Validators.required],

        IDNoImage: [''],
        KraPinImage: [''],
        PassportImage: [''],
        CvImage: [''],
  
        InstitutionName: [''],
        BusinessNature: [''],
        OrgRegNum: [''],
        PostalAddress: ['', Validators.required],
  
        RegCertImage: ['']
      }) as FormGroup & { [key: string]: AbstractControl };

      this.validationService.addOrRemoveValidationOnValue(
        form.get("Relationship")!,
        "Other",
        form,
        "Other"
      );
    }

    // Diaspora region does not require KRA PIN
      if (this.region === 1) {
        this.validationService.addOrRemoveOneValidator(
          true,
          form.get('KraPin')!,
          Validators.pattern(/^[AP]\d{9}[A-Z]$/)
        );
        form.get('KraPinImage')?.clearValidators();
      }

    if (this.trusteeForm && this.getTrustees().length > 0 && form.get('Category')?.value == this.TrusteeOptions[0]) {
      this.validationService.addOrRemoveSpecificValidators(
        true,
        form.get('Phone')!,
        [Validators.required,
          createIDsValidatorEstate('TEL', this.getTrustees(), this.trustees)
        ]
      );

      this.validationService.addOrRemove3Validators(
        true,
        form.get('Email')!,
        [ Validators.email,
          Validators.required,
          createIDsValidatorEstate('EMAIL', this.getTrustees(), this.trustees)
        ]
      );
    
      // For 'self' option control
      const fields = this.trusteeForm.get('trustees') as FormArray;
      let counter: number = 0;
    
      this.hasSelfRelationship = fields.controls.some(group => {  
        if (group.get('Relationship')?.value.toLowerCase() === 'self') {
          counter++;
        }
        return counter == this.selfRecords.length;
      });
    }

    return form;
  };

  createContactsGroup(contact: any = null, formArray: FormArray | null, trustee: any): FormGroup {
    let contactForm: FormGroup;
    if (contact) {
      contactForm = this._formBuilder.group({
        Title: [`${contact.Title || ''}`],
        FirstName: [`${contact.FirstName || ''}`],
        MiddleName: [`${contact.MiddleName || ''}`],
        LastName: [`${contact.LastName || ''}`],
        Phone: [`${contact.Phone || ''}`],
        Email: [`${contact.Email || ''}`]
      });

    } else {
      contactForm = this._formBuilder.group({
        Title: [''],
        FirstName: [''],
        MiddleName: [''],
        LastName: [''],
        Phone: [''],
        Email: ['']
      });
    }

    if (trustee?.personalDone && trustee?.Category === this.TrusteeOptions[1]) {
      contactForm.get('FirstName')?.addValidators(Validators.required);
      contactForm.get('LastName')?.addValidators(Validators.required);

      if (this.trusteeForm) {
        if (formArray) {
          this.validationService.addOrRemoveSpecificValidators(
            true,
            contactForm.get('Phone')!,
            [Validators.required, createIDsValidatorEstate('TEL', formArray, this.trustees[this.trustees.length-1].ContactPersons)]
          );
          this.validationService.addOrRemove3Validators(
            true,
            contactForm.get('Email')!,
            [Validators.required, Validators.email, createIDsValidatorEstate('EMAIL', formArray, this.trustees[this.trustees.length-1].ContactPersons)]
          );
        } else {
          contactForm.get('Phone')?.addValidators(Validators.required);
          contactForm.get('Email')?.addValidators([Validators.required, Validators.email]);
        }
      }
    }
    
    return contactForm;
  };

  async addTrustee() {
    const fields = this.trusteeForm.get('trustees') as FormArray;
    const newFormGroup = this.createTrusteeFormGroup();
    fields.push(newFormGroup);
    this.trusteeForm.setControl('trustees', fields);

    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    const newIndex = fields.length - 1;
    this.trusteePanels[newIndex] = this.generatePanelsForTrustee(newIndex);
    
    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.cdr.detectChanges();
  }
  async addNewContact(index:number) {
    const fields = this.getContacts(index);
    fields.push(this.createContactsGroup(null, fields, this.trustees[index]));
    this.getTrusteeFormGroup(index).setControl('ContactPersons', fields);

    let currentTrustees = this.trustees;
    const latestRecord = currentTrustees[index];
    const record =  this.getContacts(index);

    const existingContacts = latestRecord.ContactPersons || [];
    const newContacts = record.getRawValue() || [];

    const updatedRecord = {
      ...latestRecord,
      ContactPersons: [
        ...existingContacts,
        ...newContacts.filter(
          (newContact: any) =>
            !existingContacts.some(
              (existingContact: any) => existingContact.Phone === newContact.Phone
            )
        )
      ]
    };

    Object.assign(currentTrustees[index], updatedRecord);
    await this.estateControlService.updateRecord(5, currentTrustees);
  }
  
  async removeTrustee(i:number) {
    this.currentIndex = i;
    const fields = this.trusteeForm.get('trustees') as FormArray;
    let currentTrustees = this.trustees;

    if (currentTrustees[i] && currentTrustees[i].TrusteeID) {
      this.removeButtonText = 'Removing Trustee';
      this.loadingRemove = true;

      try {
        if (this.estateControlService.TrustID !== null) {
          const result = await this.estateControlService.removeRecord(
            'trustee',
            currentTrustees[i].TrusteeID,
            parseInt(this.estateControlService.TrustID),
            environment.baseUrl + Constants.privateTrusteeURL
          );
  
          if (result === 1) {
            this.notificationService.viewToast('success', 'Trustee removed successfully');
            fields.removeAt(i);
            currentTrustees.splice(i, 1);;
            this.estateControlService.updateRecord(5, currentTrustees);
          } else {
            this.notificationService.viewToast('error', 'Error removing record');
          }
        } else {
          console.log('Relevant IDs not found');
        }
      } catch (error) {
        console.error(':: Error !! ', error);
      }
      this.removeButtonText = this.removeBenText;
      this.loadingRemove = false;
    } else {
      if (currentTrustees[i]) {
        fields.removeAt(i);
        // Remove trustee at index
        currentTrustees.splice(i, 1);
        this.estateControlService.updateRecord(5, currentTrustees);
      } else {
        fields.removeAt(i);
      }
    }

    setTimeout(()=> {
      this.generatePanelsForTrustee(i);
      this.trustees.forEach((trustee: any, index: number) => {
        this.updateDoneStatus(index, trustee);
      });
    })
  }

  async removeContact(i:number, j: number) {
    const fields = this.getContacts(i);
    fields.removeAt(j);

    // Remove the contact from the trustees' ContactPersons array
    const currentTrustees = [...this.trustees]; // copy the array
    const trustee = { ...currentTrustees[i] };

    // Remove the contact at index j from ContactPersons
    const updatedContacts = trustee.ContactPersons
      ? [
          ...trustee.ContactPersons.slice(0, j),
          ...trustee.ContactPersons.slice(j + 1)
        ]
      : [];

    // Update the trustee with the new contacts array
    trustee.ContactPersons = updatedContacts;
    currentTrustees[i] = trustee;

    await this.estateControlService.updateRecord(5, currentTrustees);
  }

  getTrustees() : FormArray {  
    return this.trusteeForm.get("trustees") as FormArray;
  }
  getContacts(index: number) : FormArray {
    return this.getTrustees().at(index).get('ContactPersons') as FormArray;  
  }
  getTrusteeFormGroup(index: number): FormGroup {
    return this.getTrustees().at(index) as FormGroup;
  }
  getContactsFormGroup(index: number, innerdex: number): FormGroup {
    return this.getContacts(index).at(innerdex) as FormGroup;
  }

  async saveTrustee(index: number, record: FormGroup): Promise<void> {
    this.notificationService.isLoading(true);
    let tsMessage = this.addText;
    
    try {
      let temp = record.getRawValue();
      let originalContacts = [];
      let currentTrustees = this.trustees;

      if (record.getRawValue().Category.toLowerCase() === 'individual trustee') {
        temp.ContactPersons = [];
      } else {
        // Ensure ContactPersons is always an array
        if (temp.ContactPersons) {
          if (!Array.isArray(temp.ContactPersons)) temp.ContactPersons = [temp.ContactPersons];
          
          if (this.trustees[index].ContactPersons?.length > 0) {
            temp.ContactPersons = temp.ContactPersons.map((contact: any) => {
              const matchingContact = this.trustees[index].ContactPersons.find(
                (ogContact: any) => (ogContact && ogContact.ContactID && contact.Phone === ogContact.Phone)
              );
              return matchingContact 
                ? {...contact, ContactID: Number(matchingContact.ContactID)}
                : contact;
            });
          }

          originalContacts = temp.ContactPersons;
          
        } else {
          temp.ContactPersons = [];
        }
      }

      let data = {...temp, ...{TrustID: this.estateControlService.TrustID}};

      if (data.Other && data.Other != '') {
        const other = data.Other;
        data.Relationship = other;
      }
      if (data.hasOwnProperty('Other')) {
        delete data['Other'];
      }

      if (data.IDNoImage === '' || data.IDNoImage === null) {
        data.IDNoImage = {name: '', stringValue: ''};
      } else {
        data.IDNoImage = this.trustees[index].IDNoImage;
      }

      if (data.KraPinImage === '' || data.KraPinImage === null) {
        data.KraPinImage = {name: '', stringValue: ''};
      } else {
        data.KraPinImage = this.trustees[index].KraPinImage;
      }

      if (data.RegCertImage === '' || data.RegCertImage === null) {
        data.RegCertImage = {name: '', stringValue: ''};
      } else {
        data.RegCertImage = this.trustees[index].RegCertImage;
      }
      if (data.PassportImage === '' || data.PassportImage === null) {
        data.PassportImage = {name: '', stringValue: ''};
      } else {
        data.PassportImage = this.trustees[index].PassportImage;
      }
      if (data.CvImage === '' || data.CvImage === null) {
        data.CvImage = {name: '', stringValue: ''};
      } else {
        data.CvImage = this.trustees[index].CvImage;
      }

      
      if (currentTrustees[index].TrusteeID) {
        data = {...data, ...{TrusteeID: currentTrustees[index].TrusteeID}};
      }

      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.privateTrusteeURL, data);
      // console.log('::::: RESPONSE\n', response);

      if (response.Status === 1) {
        let latestRecord = currentTrustees[index];

        if (this.autofilled) {
          latestRecord.personalDone = true;
          latestRecord.contactsDone = true;
        }

        // remove images from record to NOT replace object images!!!
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(record.getRawValue()).filter(([key]) => !key.includes('Image'))
        );

        const updatedRecord = {
          ...latestRecord,
          ...recordValueWithoutImages,
          ...{TrusteeID: response.TrusteeID}};
        Object.assign(currentTrustees[index], updatedRecord);

        this.estateControlService.updateRecord(5, currentTrustees); 
         
        currentTrustees = this.trustees; // update var
        let currentRecord = currentTrustees[index];

        if (currentTrustees[index].contactsDone) {
          tsMessage = this.updateText;
          
          if (record.getRawValue().Category.toLowerCase() === 'individual trustee') {
            currentRecord.ContactPersons = originalContacts;
          } else {
            if (response.ContactPersons?.length > 0) {
              currentRecord.ContactPersons = currentRecord.ContactPersons.map((contact: any) => {
                const matchingContact = response.ContactPersons.find(
                  (ogContact: any) => contact.Phone === ogContact.Phone
                );
                return matchingContact 
                  ? {...contact, ContactID: Number(matchingContact.ContactID)}
                  : contact;
              });
            }
          }

          if (data.IDNoImage && data.IDNoImage.stringValue.length > 5 && response.IdURL) {
            currentRecord = {...currentRecord, ...{IDURL: response.IdURL, SavedID: currentRecord.IDNoImage}};
            if (data.Relationship.toLowerCase() != 'self' ) {
              this.estateControlService.removeFromDocSummary('ID', 'Trustee', currentRecord.TrusteeID);
              this.estateControlService.updateDocSummary(response.IdURL);
            }
          }
          if (data.KraPinImage && data.KraPinImage.stringValue.length > 5 && response.KraURL) {
            currentRecord = {...currentRecord, ...{KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage}};
            if (data.Relationship.toLowerCase() != 'self' ) {
              this.estateControlService.removeFromDocSummary('PIN', 'Trustee', currentRecord.TrusteeID);
              this.estateControlService.updateDocSummary(response.KraURL);
            }
          }
          if (data.PassportImage && data.PassportImage.stringValue.length > 5 && response.PassportURL) {
            currentRecord = {...currentRecord, ...{PassportURL: response.PassportURL, SavedPassport: currentRecord.PassportImage}};
            if (data.Relationship.toLowerCase() != 'self' ) {
              this.estateControlService.removeFromDocSummary('PASSPORT', 'Trustee', currentRecord.TrusteeID);
              this.estateControlService.updateDocSummary(response.PassportURL);
            }
          }
          if (data.RegCertImage && data.RegCertImage.stringValue.length > 5 && response.RegCertURL) {
            currentRecord = {...currentRecord, ...{RegCertURL: response.RegCertURL, SavedRegCert: currentRecord.RegCertImage}};
            this.estateControlService.removeFromDocSummary('RegCert', 'Trustee', currentRecord.TrusteeID);
            this.estateControlService.updateDocSummary(response.RegCertURL);
          }
          if (data.CvImage && data.CvImage.stringValue.length > 5 && response.CvURL) {
            currentRecord = {...currentRecord, ...{CvURL: response.CvURL, SavedCV: currentRecord.CvImage}};
            this.estateControlService.removeFromDocSummary('CV', 'Trustee', currentRecord.BeneficiaryID);
            this.estateControlService.updateDocSummary(response.CvURL);
          }
          currentRecord.done = true;
          Object.assign(currentTrustees[index], currentRecord);
          this.estateControlService.updateRecord(5, currentTrustees);

          if (this.autofilled) this.autofilled = false;

        } else {
          if (record.getRawValue().Category.toLowerCase() === 'individual trustee') {
            currentRecord.personalDone = true;
            currentRecord.contactsDone = true;
            Object.assign(currentTrustees[index], currentRecord);

            this.estateControlService.updateRecord(5, currentTrustees);
            if (this.trustees.length <= 1) this.estateControlService.updatePrivateTrustProgress('Trustees');  

            this.validationService.addOrRemoveValidator(true,
                this.getTrusteeFormGroup(index).get('IDNoImage')!);
            this.validationService.addOrRemoveValidator(true,
              this.getTrusteeFormGroup(index).get('KraPinImage')!);
            this.validationService.addOrRemoveValidator(true,
              this.getTrusteeFormGroup(index).get('PassportImage')!);
            this.validationService.addOrRemoveValidator(true,
              this.getTrusteeFormGroup(index).get('CvImage')!);

          } else {
            if (currentTrustees[index].personalDone) {
              if (response.ContactPersons?.length > 0) {
                currentRecord.ContactPersons = currentRecord.ContactPersons.map((contact: any) => {
                  const matchingContact = response.ContactPersons.find(
                    (ogContact: any) => contact.Phone === ogContact.Phone
                  );
                  return matchingContact 
                    ? {...contact, ContactID: Number(matchingContact.ContactID)}
                    : contact;
                });
              }
              currentRecord.contactsDone = true;
              Object.assign(currentTrustees[index], currentRecord);

              this.estateControlService.updateRecord(5, currentTrustees);

              this.validationService.addOrRemoveValidator(true,
                this.getTrusteeFormGroup(index).get('RegCertImage')!);

              this.validationService.addOrRemoveValidator(true,
                this.getTrusteeFormGroup(index).get('KraPinImage')!);

            } else {
              currentRecord.personalDone = true;

              if (record.value.Category === this.TrusteeOptions[1]) { // institutions setup for contact persons
                try {
                  this.validationService.addOrRemoveValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('FirstName')!
                  );
                  this.validationService.addOrRemoveValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('LastName')!
                  );
                  
                  this.validationService.addOrRemoveOneValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('Phone')!,
                    Validators.required
                  );
        
                  this.validationService.addOrRemoveSpecificValidators(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('Email')!,
                    [
                      Validators.required,
                      Validators.email]
                  );
                } catch (error) { }
              }

              Object.assign(currentTrustees[index], currentRecord);

              this.estateControlService.updateRecord(5, currentTrustees);
              if (this.trustees.length <= 1) this.estateControlService.updatePrivateTrustProgress('Trustees');
            }
          }
        }
        if (!environment.production) console.log('>> New Trustees !! \n', this.trustees);
        this.notificationService.viewToast('success', tsMessage);
        this.updateDoneStatus(index, currentRecord)

      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }

  async updateProgress(): Promise<void> {
    if (!this.trustees[this.trustees.length-1].done && this.trusteeForm.valid) {
      const tees = this.trusteeForm.get('trustees') as FormArray;
      await this.saveTrustee(tees.length - 1, this.getTrusteeFormGroup(tees.length - 1));
    }
    this.saveProgress();
  }

  // ==============  EXPANSION SECTION   =================
  @ViewChild('trusteeInfo') trusteeInfo!: TemplateRef<any>;
  @ViewChild('contactInfo') contactInfo!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;


  generatePanelsForTrustee = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.trusteeInfo || !this.contactInfo || !this.uploadDocs || !this.trustees[i]) {
      return [];
    }
    const isIndividual = this.getTrusteeFormGroup(i).get('Category')?.value === this.TrusteeOptions[0];
    
    if (isIndividual) {
      return [
        {
          title: 'Trustee Information',
          contentTemplate: this.trusteeInfo,
          context: { index: i },
          expanded: !(this.trustees[i].personalDone),
          done: (this.trustees[i].personalDone)
        },
        {
          title: 'Upload Documents',
          contentTemplate: this.uploadDocs,
          context: { index: i },
          disabled: !(this.trustees[i].contactsDone),
          expanded: (this.trustees[i].contactsDone && !this.trustees[i].done),
          done: (this.trustees[i].done)
        }
      ];
    } else {
      return [
        {
          title: 'Trustee Information',
          contentTemplate: this.trusteeInfo,
          context: { index: i },
          expanded: !(this.trustees[i].personalDone),
          done: (this.trustees[i].personalDone)
        },
        {
          title: 'Contact Person Information',
          contentTemplate: this.contactInfo,
          context: { index: i },
          disabled: !(this.trustees[i].personalDone),
          expanded: (this.trustees[i].personalDone && !this.trustees[i].contactsDone),
          done: (this.trustees[i].contactsDone)
        },
        {
          title: 'Upload Documents',
          contentTemplate: this.uploadDocs,
          context: { index: i },
          disabled: !(this.trustees[i].contactsDone),
          expanded: (this.trustees[i].contactsDone && !this.trustees[i].done),
          done: (this.trustees[i].done)
        }
      ];
    }
  }

  updateDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.trusteePanels = this.trusteePanels || [];
    
    // Initialize if missing or invalid
    if (!this.trusteePanels[i] || this.trusteePanels[i].length < 2) {
      this.trusteePanels[i] = this.generatePanelsForTrustee(i);
    }

    const isIndividual = this.getTrusteeFormGroup(i).get('Category')?.value === this.TrusteeOptions[0];
    const panels = this.trusteePanels[i];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.personalDone;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
      panels[0].expanded = !value.personalDone;
    }
    
    if (panels[1]) {
      panels[1].done = isIndividual ? value.done : value.contactsDone;
      panels[1].context = panels[1].context || { index: i };
      panels[1].disabled = !value.personalDone;
      panels[1].expanded = value.personalDone && (isIndividual ? !value.done : !value.contactsDone);
    }
    
    if (panels[2]) {
      panels[2].context = panels[2].context || { index: i };
      panels[2].done = value.done;
      panels[2].disabled = !value.contactsDone;
      panels[2].expanded = value.contactsDone && !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.BeneficiaryID && !value.done && i == this.trustees.length-1) {
          const trusteeName = isIndividual ? `${value.FirstName} ${value.LastName}` : `${value.InstitutionName}`
          this.notificationService.viewToast(
            'info',
            `Trustee ${trusteeName}`,
            `Please continue to ${
              value.contactsDone ? panels[(isIndividual ?  1 : 2)].title :
              'add '+panels[1].title
            }`
          );
        }
        
      } catch (error) {}
      
    })
  }

  async updateRecord(index: number) {
    await this.saveTrustee(index, this.getTrusteeFormGroup(index));
  }

  private setupFormChangeListeners() {
    this.cleanupFormChangeListeners();
    
    this.getTrustees().controls.forEach((control, index) => {
      // General form changes
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        this.cdr.detectChanges();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {
    const control = this.getTrustees().at(index) as FormGroup;
    
    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }

  private loggedErrors = new Set<string>();

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const trustee = this.trustees[index];
      const formGroup = this.getTrusteeFormGroup(index);
      
      if (!trustee?.done || !formGroup) {
        return true;
      }

      const isIndividual = trustee.Category === this.TrusteeOptions[0];

      const fieldsToCompare = isIndividual ? [
        'Title', 'FirstName', 'MiddleName', 'LastName',
          'Phone', 'Email', 'IDNo', 'KraPin', 'PostalAddress', 'Relationship'
      ] : [
        'InstitutionName', 'BusinessNature', 'OrgRegNum', 
        'KraPin', 'PostalAddress'
      ];

      const basicFieldsMatch = fieldsToCompare.every(field => {
        const recordValue = trustee[field];
        const formValue = formGroup.get(field)?.value;
        const valuesMatch = (formValue || '') === (recordValue || '');
        
        // If either value is empty, consider this field as matching
        return valuesMatch;
      });

      let filesMatch = true;

      if (isIndividual) {
        filesMatch =
          trustee.IDNoImage.name === trustee.SavedID.name &&
          trustee.KraPinImage.name === trustee.SavedPIN.name &&
          trustee.PassportImage.name === trustee.SavedPassport.name &&
          trustee.CvImage.name === trustee.SavedCV.name;
      } else {
        filesMatch =
          trustee.RegCertImage.name === trustee.SavedRegCert.name &&
          trustee.KraPinImage.name === trustee.SavedPIN.name;
      }

      return basicFieldsMatch && filesMatch;
      // Compare all relevant fields
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++

  submitForm(): void {
    if (this.trustees[this.trustees.length-1].done === true) {
      this.navigateFunction();
      
    } else {
      const bens = this.trusteeForm.get('trustees') as FormArray;
      this.saveTrustee(bens.length - 1, this.getTrusteeFormGroup(bens.length - 1));
    }
  }

  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTab(6);
    this.estateControlService.page5Done = true;
  }
}
